import { render, staticRenderFns } from "./DailyFerryCreate.vue?vue&type=template&id=477c3540"
import script from "../../controllers/daily_ferry/daily-ferry-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/daily_ferry/daily-ferry-create.js?vue&type=script&lang=js&external"
import style0 from "./DailyFerryCreate.vue?vue&type=style&index=0&id=477c3540&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports